module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAzCAYAAABBhfLmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAC9SURBVEhLY/wPBAxEArjif0By/sXvDDvu/GR48OEvg4IAM4OHCjtDoj4nAxMjWC1EMUhh0uZPDKee/oKIIgEzaTaGeb58YA1MIAGQidgUggBIHCQPAmDFIKvxAZg8WDHIjfgATB6sGOQZfAAmD1YM8jU+AJMHKwYFD8jX2ABIHCQPAljD+c67PwwqQiwY4cwAUowO9t3/CWWhArAziAWjipHBqGJkMKoYGYwqRgajipHBqGJkQDvFJLRkGBgA3Jt1uahPpeMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/memorabilia.png
// module id = HYIF
// module chunks = 1